import { MingcutePackageLine } from '../../../../assets/icons/Icons'
import { ExtraPackagesData } from '../../../../types/client';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedPackageToUpdate, Default, selectTypeOfShowClient, selectUpdatePackage, selectUpdatePackageLocalId, setClearTypeOfShowClient, setSelectedPackageToUpdate, setSelectedPackageView, setTypeOfShowClient, updatePackageFromApi } from '../../../../features/client/clientSlice';
import { useClientPopulateWrap } from '../../../../hooks/populate/useClientPopulateWrap';
import useClientAction from '../../../../hooks/actions/useClientAction';
import { setTypeOfAdditionalModal } from '../../../../features/modal/modalSlice';
import { formatNumber } from '../../../../utils/formatAmount';

interface ClientModalAllPackageFromApiProps {
    pkg: ExtraPackagesData;
    typeOfAction: 'newClient' | 'update'
}

export default function ClientModalAllPackageFromApi({ pkg, typeOfAction }: ClientModalAllPackageFromApiProps) {

    const isCantUpdatePackage = pkg.isDefaultPackage
    const { repopulateAll } = useClientPopulateWrap()
    const clientTypeOfShow = useSelector(selectTypeOfShowClient);
    const { handleUpdateClientPackage } = useClientAction()
    const selectedPackage = useSelector(selectUpdatePackage)
    const selectedPackageLocalId = useSelector(selectUpdatePackageLocalId)
    const dispatch = useDispatch()
    const isUpdatePackageSchedule = clientTypeOfShow === 'showUpdatePackageSchedule'
    const isUpdate = selectedPackageLocalId === pkg.localId && isUpdatePackageSchedule;
    const currentPackage = selectedPackageLocalId === pkg.localId ? selectedPackage : pkg;
    const selectedPackageToView : Default = { id: pkg.packageId, name: pkg.packageName, }
    const isAmountBased = pkg.packageType === 'Amount-Based' 
    const isCupBased = pkg.packageType === 'Cup-Based' 
    const label1 = isAmountBased ? 'Deposit amount' : isCupBased ? 'Amount' : ''
    const label2 = isAmountBased ? 'Total consume' : isCupBased ? 'Cups' : ''
    const remainingBalance = `${formatNumber(pkg.netSpent ?? 0)}/${formatNumber(Number(pkg.downpayment))}`
    const remainingCups = `${formatNumber(pkg.remainingQty)}/${formatNumber(pkg.quantity)}`
    const isDefaultPackage = pkg.isDefaultPackage ? '0' : pkg.totalValue?.toLocaleString()
    const remainingCount = isAmountBased ? remainingBalance : isCupBased ? remainingCups : ''

    if(!currentPackage) return null;

    const handleUpdateProducts = () => {
        dispatch(setSelectedPackageToUpdate(pkg));
        dispatch(setTypeOfShowClient('showUpdateProducts'));
    }

    const handleUpdate = () => {
        dispatch(setSelectedPackageToUpdate(pkg));
        dispatch(setTypeOfShowClient('showUpdatePackageSchedule'));
    };

    const handleCancel = () => {
        dispatch(clearSelectedPackageToUpdate());
        dispatch(setClearTypeOfShowClient());
        repopulateAll();
    };

    const handleViewPackage = () => {
        if(!selectedPackageToView.id) return;
        if(!selectedPackageToView.name) return;

        dispatch(setSelectedPackageView({
            id: selectedPackageToView.id,
            name: selectedPackageToView.name,
        }))

        if (typeOfAction === 'newClient' && isDefaultPackage) {
            dispatch(setTypeOfAdditionalModal('viewDefaultPackage'));
            return;
        }
        if (typeOfAction === 'update') {
            dispatch(setSelectedPackageToUpdate(pkg));
            dispatch(setTypeOfShowClient('showPackageProduct'));
            return;
        }
    };

    return (
        <div className="flex flex-col justify-between rounded p-2 cursor-pointer transition-colors bg-white ring-1 ring-cbColor border-t-8 border-cbColor space-y-1.5 ">
            <div className='space-y-1'>
                <div className='flex justify-between flex-row-reverse items-center'>
                    <MingcutePackageLine height={25} width={25}/>                                       
                    <p className='text-[13px] font-medium truncate'>
                        {pkg.packageName}
                    </p>
                </div>
                {(!isUpdate || !isAmountBased) && (
                    <>
                        <div className='flex justify-between'>
                            <p className='text-[13px]'>{label1}</p>
                            <p className='text-[13px]'>
                                {isDefaultPackage}
                            </p>
                        </div>
                        <div className={`flex justify-between`}>
                            <p className='text-[13px]'>{label2}</p>
                            <p className='text-[13px]'>
                                {remainingCount}
                            </p>
                        </div>
                        {isAmountBased && (
                            <div className='flex justify-between'>
                                <p className='text-[13px]'>{'Deposit date'}</p>
                                <p className='text-[13px]'>
                                    {pkg.receiptDate ?? 0}
                                </p>
                            </div>
                        )}
                        {isAmountBased && (
                            <div className='flex justify-between'>
                                <p className='text-[13px]'>{'Receipt number'}</p>
                                <p className='text-[13px]'>
                                    {pkg.receiptId ?? ''}
                                </p>
                            </div>
                        )}
                    </>
                )}
                {isAmountBased && isUpdate && (
                    <>
                        <div className='grid grid-cols-2 gap-1'>
                            <div className='flex items-center'>
                                <p className='text-[13px] font-medium'>Deposit amount:</p>
                            </div>
                            <div className='grid grid-cols-1 gap-1 w-full'>
                                <input
                                    className='text-[13px] border border-gray-300 px-2 py-1 shadow-sm rounded' 
                                    type="text"
                                    value={formatNumber(currentPackage?.downpayment ?? 0)}
                                    onChange={(e) => dispatch(updatePackageFromApi({ localId: currentPackage.localId ?? '', field: 'downpayment', value: Number(e.target.value.replace(/,/g, "")) || ''}))}
                                    disabled={!isUpdate}
                                />
                            </div>
                        </div>
                        <div className='grid grid-cols-2 gap-1'>
                            <div className='flex items-center'>
                                <p className='text-[13px] font-medium'>Deposit date:</p>
                            </div>
                            <div className='grid grid-cols-1 gap-1 w-full'>
                                <input
                                    className='text-[13px] border border-gray-300 px-2 py-1 shadow-sm rounded' 
                                    type="date"
                                    value={currentPackage.receiptDate ?? '-'}
                                    onChange={(e) => dispatch(updatePackageFromApi({ localId: currentPackage.localId ?? '', field: 'receiptDate', value: e.target.value}))}
                                    disabled={!isUpdate}
                                />
                            </div>
                        </div>
                        <div className='grid grid-cols-2 gap-1'>
                            <div className='flex items-center'>
                                <p className='text-[13px] font-medium'>Receipt number:</p>
                            </div>
                            <div className='grid grid-cols-1 gap-1 w-full'>
                                <input
                                    className='text-[13px] border border-gray-300 px-2 py-1 shadow-sm rounded' 
                                    type="text"
                                    value={currentPackage.receiptId ?? '-'}
                                    onChange={(e) => dispatch(updatePackageFromApi({ localId: currentPackage.localId ?? '', field: 'receiptId', value: e.target.value}))}
                                    disabled={!isUpdate}
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className='flex flex-col space-y-2'>
                <div className='flex flex-col space-y-1'>
                    <p className='text-xs font-medium'>Available From</p>
                    <div className='grid grid-cols-2 gap-1 w-full'>
                        <input
                            className='text-xs border border-gray-300 px-2 py-1 shadow-sm rounded' 
                            type="date"
                            value={currentPackage.startDate}
                            onChange={(e) => dispatch(updatePackageFromApi({ localId: currentPackage.localId ?? '', field: 'startDate', value: e.target.value}))}
                            disabled={!isUpdate}
                        />
                        <input 
                            className='text-xs border border-gray-300 px-2 py-1 shadow-sm rounded' 
                            type="time" 
                            value={currentPackage.startTime}
                            onChange={(e) => dispatch(updatePackageFromApi({ localId: currentPackage.localId ?? '', field: 'startTime', value: e.target.value}))}
                            disabled={!isUpdate}
                        />
                    </div>
                </div>
                <div className='flex flex-col space-y-1'>
                    <p className='text-xs font-medium'>Available To</p>
                    <div className='grid grid-cols-2 gap-1 w-full'>
                        <input 
                            className='text-xs border border-gray-300 px-2 py-1 shadow-sm rounded' 
                            type="date" 
                            value={currentPackage.endDate}
                            onChange={(e) => dispatch(updatePackageFromApi({ localId: currentPackage.localId ?? '', field: 'endDate', value: e.target.value}))}
                            disabled={!isUpdate}
                        />
                        <input 
                            className='text-xs border border-gray-300 px-2 py-1 shadow-sm rounded' type="time" 
                            value={currentPackage.endTime}
                            onChange={(e) => dispatch(updatePackageFromApi({ localId: currentPackage.localId ?? '', field: 'endTime', value: e.target.value}))}
                            disabled={!isUpdate}
                        />
                    </div>
                </div>
                <div className={`w-full grid gap-1 ${isCantUpdatePackage ? 'grid-cols-1' : 'grid-cols-1'}`}>
                    { isCantUpdatePackage ? (
                            <button 
                                onClick={handleViewPackage}
                                className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                            >
                                View
                            </button>
                        ) : (
                            isUpdate ? (
                                <>
                                    <button 
                                        className='py-1.5 bg-gray-300 text-gray-900 text-[12px] rounded'
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        onClick={handleUpdateClientPackage}
                                        className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                                    >
                                        Save
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button 
                                        onClick={handleViewPackage}
                                        className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                                    >
                                        View
                                    </button>
                                    <button 
                                        onClick={handleUpdate}
                                        className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                                    >
                                        Update Schedule
                                    </button>
                                    {isAmountBased && (
                                        <button 
                                            onClick={() => handleUpdateProducts()}
                                            className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                                        >
                                            Update Product
                                        </button>
                                    )}
                                </>
                            )
                        )
                    }
                </div>
            </div>
        </div>
    )
}
